module.exports = ".edit-tags-container {\n  width: 400px;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n      -ms-flex-direction: column;\n          flex-direction: column; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/offers/campaigns/edit-tags-dialog/edit-tags-dialog.component.scss
// module id = ./src/app/modules/offers/campaigns/edit-tags-dialog/edit-tags-dialog.component.scss
// module chunks = main